import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/components';

function NoAccess(): React.ReactNode {
  const { t } = useTranslation('label-perf');

  const formUrl = `https://docs.google.com/forms/d/e/1FAIpQLSfur5kIgPQKggE-eO2vGjGI4PhIvVugR8El1z7IB61DeiuGxg/viewform?entry.1328386153=${window.location.origin}`;

  return (
    <div
      data-testid="no-access-container"
      className="flex h-full flex-col items-center justify-center text-center"
    >
      <Icon type="bell-on" variant="regular" size="4x" className="mb-md" />
      <p className="mb-sm text-body-xl font-normal">
        {t('error.noAccessTitle')}
      </p>
      <p className="text-body-md text-subtle">
        <Trans
          i18nKey="error.noAccessDescription"
          t={t}
          components={[
            <br key="0" />,
            <a
              key="1"
              href={formUrl}
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              ...
            </a>,
          ]}
        />
      </p>
    </div>
  );
}

NoAccess.displayName = 'NoAccess';

export { NoAccess };
